import { Fragment, useState } from 'react';

import { makeStyles } from '@material-ui/core';

import {
  CommentFragment,
  CommentReplyFragment,
  getTypeOrNull,
} from '@spotify/confidence-graphql';
import {
  useCommentApi,
  useCommentReplies,
} from '@spotify/plugin-confidence-comments-react';

import Comment from './Comment';
import CommentInput from './CommentInput';
import { useActivityFeedItemContext } from './context';

const useStyles = makeStyles(theme => ({
  replyContainer: {
    marginLeft: theme.spacing(6),
    marginTop: theme.spacing(4),
  },
}));

const getEmojiReactions = (comment: CommentFragment | CommentReplyFragment) => {
  const reactionSummary = getTypeOrNull(comment.queryReactionSummary);
  return reactionSummary?.summary;
};

export const Thread = ({ comment }: { comment: CommentFragment }) => {
  const classes = useStyles();
  const [isReplying, setIsReplying] = useState(false);
  const { activity } = useActivityFeedItemContext();

  const { commentReplies } = useCommentReplies(comment.name);

  const { addReply } = useCommentApi(activity.name);

  return (
    <Fragment key={comment.name}>
      <Comment
        key={comment.name}
        name={comment.name}
        author={getTypeOrNull(comment.author)}
        createTime={comment.createTime}
        content={comment.content}
        reactions={getEmojiReactions(comment)}
        onReply={() => setIsReplying(true)}
      />
      {(commentReplies.length > 0 || isReplying) && (
        <div className={classes.replyContainer}>
          {commentReplies.map(reply => (
            <Comment
              key={reply.name}
              name={reply.name}
              author={getTypeOrNull(reply.author)}
              createTime={reply.createTime}
              content={reply.content ?? ''}
              reactions={getEmojiReactions(reply)}
            />
          ))}
          {/* FIXME: load more replies */}
          <CommentInput
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus={isReplying}
            onSubmit={text => {
              addReply(comment.name, text);
            }}
          />
        </div>
      )}
    </Fragment>
  );
};
